import React from "react";
import { $gray } from "_variables";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./IconButton.css";

const IconButton = ({ alignIcon, color, dimensions, icon, label, onClick, size }) => {
  const Icon = icon;

  return (
    <button
      className={cx(styles.button, size && styles[size], {
        [styles.iconRight]: alignIcon === "right",
      })}
      onClick={onClick}
      style={{ color }}
      type="button"
    >
      <Icon dimensions={dimensions} size={size} />
      {label && <div className={styles.text}>{label}</div>}
    </button>
  );
};

IconButton.propTypes = {
  alignIcon: PropTypes.oneOf(["left", "right"]),
  color: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["xlarge", "large", "small", "xs", "xxs"]),
  onClick: PropTypes.func.isRequired,
  dimensions: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string,
  }),
};

IconButton.defaultProps = {
  alignIcon: "left",
  color: $gray,
};

export default IconButton;
